import { AntDesign } from "@expo/vector-icons";
import { observer } from "mobx-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Dimensions,
  Image,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  View,
  Text,
} from "react-native";
import { Button } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import { Row, Table } from "react-native-table-component";
import sendNotarizeInvite from "../../networking/api/verification/sendNotarizeInvite";
import updateNotarize from "../../networking/api/verification/updateNotarize";
import updatePoi from "../../networking/api/verification/updatePoi";
import { navigate } from "../../routes/Global";
import state from "../../store/Store";
import { Feather } from "@expo/vector-icons";
import _ from "lodash";
import approveNotarize from "../../networking/api/verification/approveNotarize";
import rejectNotarize from "../../networking/api/verification/rejectNotarize";

const { height, width } = Dimensions.get("window");

const Dispute = observer(({ data, loading }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(data);
  }, [data, data.map((o) => o?.documents)]);

  const tableHead = [
    "#",
    "Full Name",
    "Reason",
    "View Profile",
    "Approve Dispute",
    "Reject Dispute",
  ];

  const tableData = items?.map((record, index) => {
    let number = index + 1;
    const { firstName, lastName, dispute } = record || {};
    const { desc } = dispute || {};
    return [
      number,
      firstName + " " + lastName,
      desc,
      <Button
        title="View"
        buttonStyle={styles.buttonStyle}
        titleStyle={styles.buttonTitle}
        onPress={() => navigate("viewnotarizedetails", { item: record })}
      />,
      <Button
        title="Approve"
        buttonStyle={[styles.buttonStyle, { backgroundColor: "green" }]}
        titleStyle={styles.buttonTitle}
      />,
      <Button
        title="Reject"
        buttonStyle={[styles.buttonStyle, { backgroundColor: "red" }]}
        titleStyle={styles.buttonTitle}
      />,
    ];
  });
  return (
    <Table>
      <Row
        data={tableHead}
        style={styles.head}
        textStyle={styles.headerText}
        flexArr={tableHead.map((o, i) => (i === 0 ? 0.25 : 1))}
      />
      <ScrollView
        nestedScrollEnabled={true}
        contentContainerStyle={styles.scrollView}
        bounces={false}
        showsVerticalScrollIndicator={false}
      >
        {loading ? (
          <ActivityIndicator animating size="large" />
        ) : (
          <SafeAreaView style={styles.view}>
            {items.length === 0 ? (
              <Text style={styles.notFound}>No records found</Text>
            ) : (
              <Table>
                {tableData?.map((rowData, index) => (
                  <View key={rowData + index.toString()}>
                    <Row
                      data={rowData}
                      style={styles.row}
                      textStyle={styles.text}
                      flexArr={tableHead.map((o, i) => (i === 0 ? 0.25 : 1))}
                    />
                    <View style={styles.borderLine} />
                  </View>
                ))}
              </Table>
            )}
          </SafeAreaView>
        )}
      </ScrollView>
    </Table>
  );
});

export default Dispute;

const styles = StyleSheet.create({
  headerAltText: { fontFamily: "avenir", fontSize: RFValue(9) },
  headerRow: { alignItems: "center", flexDirection: "row", margin: 6 },
  notFound: {
    fontFamily: "avenir-h",
    fontSize: RFValue(22),
    textAlign: "center",
    color: "gray",
  },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
  },
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    width: width * 0.08,
    marginBottom: 2.5,
    paddingVertical: 5,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  borderLine: { borderBottomWidth: 0.5 },
  view: { marginBottom: height * 0.025 },
  tableStyle: { borderColor: "transparent" },
  scrollView: { flexGrow: 0 },
  imageStyle: {
    width: 35,
    height: 35,
    borderRadius: 35 / 2,
  },
  container: {
    flex: 1,
    padding: 16,
    marginBottom: 36,
    backgroundColor: "#fff",
  },
  head: { backgroundColor: "#ECECF4", flexGrow: 0 },
  text: { margin: 6, fontSize: RFValue(9), fontFamily: "avenir" },
  headerText: {
    margin: 6,
    fontSize: RFValue(9),
    fontFamily: "avenir",
  },
  row: { flexDirection: "row", backgroundColor: "white", marginTop: 10 },
  image: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#d3d3d3",
    backgroundColor: "gray",
  },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
